import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useWA, useLoad, useDebounced, PageHead, Card, Tabs, Search, Btn, Badge, StatusBadge, Modal, Pager, Skeleton, Empty, ErrorBox, Avatar, num, money, fdate, fdt, ago, exportCsv } from "../ui";
import { absUrl } from "../api";
import { GrantModal } from "./Users";

const TAKE = 30;
const TABS = [["PENDING", "Pending"], ["ACTIVE", "अभी चालू"], ["APPROVED", "Approved"], ["REJECTED", "Rejected"], ["CANCELLED", "Cancelled"], ["ALL", "सभी"]];

export default function Payments() {
  const { run, confirm, prompt } = useWA();
  const loc = useLocation();
  const qs = new URLSearchParams(loc.search);
  const [status, setStatus] = useState(qs.get("status") || "PENDING");
  const [q, setQ] = useState(qs.get("q") || "");
  const [skip, setSkip] = useState(0);
  const [shot, setShot] = useState(null);
  const [grant, setGrant] = useState(false);
  const dq = useDebounced(q);
  useEffect(() => setSkip(0), [status, dq]);
  const { data, loading, error, reload } = useLoad("payments", { status, q: dq, take: TAKE, skip }, [status, dq, skip]);
  const items = (data && data.items) || [];

  const act = async (action, params, msg, ask) => {
    if (ask && !(await confirm(ask))) return;
    try {
      await run(action, params, msg);
      reload();
    } catch (e) {
      /* toast */
    }
  };

  const approve = (p) => act("payReview", { id: p.id, decision: "approve" }, "Plan चालू हो गया, user को message गया", { title: "पहले बैंक में UTR और रकम मिला ली?", text: `UTR ${p.utr} · ${money(p.amount)} · ${p.plan}`, ok: "हाँ, Approve करें" });
  const reject = async (p) => {
    const note = await prompt({ title: "Reject का कारण", text: "यह user को दिखेगा।", defaultValue: "UTR गलत है या पेमेंट नहीं मिला" });
    if (note !== null) act("payReview", { id: p.id, decision: "reject", note }, "Request reject हो गई");
  };
  const extend = async (p) => {
    const d = await prompt({ title: "कितने दिन और बढ़ाएँ?", defaultValue: "7" });
    if (d) act("payUpdate", { id: p.id, op: "extend", days: Number(d) }, `${d} दिन बढ़ गए`);
  };
  const setEnd = async (p) => {
    const d = await prompt({ title: "Plan कब तक चले? (YYYY-MM-DD)", defaultValue: (p.until || new Date().toISOString()).slice(0, 10) });
    if (d) act("payUpdate", { id: p.id, op: "setEnd", until: new Date(d + "T23:59:00").toISOString() }, "End date बदल गई");
  };

  return (
    <div>
      <PageHead icon="fa-solid fa-indian-rupee-sign" title="Payments" subtitle="UPI payments verify करें, plans चालू/बंद करें"
        actions={
          <>
            <Btn icon="fa-solid fa-download" disabled={!items.length} onClick={() => exportCsv(items.map((p) => ({ name: p.name, email: p.email, plan: p.plan, amount: p.amount, utr: p.utr, status: p.status, submitted: p.at, until: p.until, note: p.note })), "ycnp-payments")}>CSV</Btn>
            <Link to="/website/plans"><Btn icon="fa-solid fa-crown">Plans & prices</Btn></Link>
            <Btn variant="primary" icon="fa-solid fa-gift" onClick={() => setGrant(true)}>हाथ से plan दें</Btn>
          </>
        } />
      <div className="flex flex-col gap-3 mb-4">
        <Tabs tabs={TABS} value={status} onChange={setStatus} />
        <div className="flex flex-wrap items-center gap-3">
          <Search value={q} onChange={setQ} placeholder="UTR, नाम या email…" className="flex-1 min-w-[220px]" />
          {data && <span className="text-sm wa-muted">{num(data.total)} payments · कुल <b className="text-[color:var(--wa-ink)]">{money(data.sum)}</b></span>}
        </div>
      </div>
      <ErrorBox msg={error} retry={reload} />
      {loading && !data ? <Skeleton rows={4} h={120} /> : !items.length ? (
        <Card><Empty icon={status === "PENDING" ? "fa-solid fa-check-double" : "fa-solid fa-receipt"} title={status === "PENDING" ? "कोई payment request बाकी नहीं 🎉" : "कुछ नहीं मिला"} /></Card>
      ) : (
        <div className="space-y-3">
          {items.map((p) => {
            const live = p.status === "APPROVED" && p.until && new Date(p.until) > new Date();
            return (
              <div key={p.id} className="wa-card wa-in p-4 flex flex-wrap gap-4 items-start">
                {p.screenshot && p.screenshot !== "/manual" ? (
                  <button type="button" onClick={() => setShot(p)} className="shrink-0 group relative" aria-label="Screenshot देखें">
                    <img src={absUrl(p.screenshot)} alt="" className="w-20 h-28 object-cover rounded-xl border wa-line" />
                    <span className="absolute inset-0 rounded-xl bg-black/40 opacity-0 group-hover:opacity-100 grid place-items-center text-white"><i className="fa-solid fa-magnifying-glass-plus" /></span>
                  </button>
                ) : (
                  <span className="w-20 h-28 rounded-xl grid place-items-center text-center text-[11px] wa-muted border wa-line shrink-0"><span><i className="fa-solid fa-gift text-lg block mb-1" />Manual</span></span>
                )}
                <div className="flex-1 min-w-[240px]">
                  <div className="flex flex-wrap items-center gap-2">
                    <Avatar name={p.name || p.email} size={26} />
                    <Link to={`/website/users?open=${p.userId}`} className="font-bold hover:underline">{p.name || "—"}</Link>
                    <span className="text-[12.5px] wa-muted">{p.email}</span>
                    <StatusBadge s={p.status} />
                    {live && <Badge tone="green" icon="fa-solid fa-bolt">चालू</Badge>}
                  </div>
                  <div className="flex flex-wrap gap-x-5 gap-y-1 mt-2 text-sm">
                    <span>Plan <b>{p.plan}</b></span>
                    <span>रकम <b className="tabular-nums">{money(p.amount)}</b></span>
                    <span>UTR <b className="select-all font-mono">{p.utr}</b></span>
                  </div>
                  <p className="text-[12px] wa-muted mt-1.5">
                    भेजा {fdt(p.at)} ({ago(p.at)}){p.reviewedAt ? ` · देखा ${fdate(p.reviewedAt)}` : ""}{p.until ? ` · ${live ? "चलेगा" : "खत्म"} ${fdate(p.until)}` : ""}
                  </p>
                  {p.note && <p className="text-[12.5px] mt-1.5 px-2.5 py-1.5 rounded-lg inline-block" style={{ background: "color-mix(in srgb, var(--wa-ink) 5%, transparent)" }}>📝 {p.note}</p>}
                </div>
                <div className="flex flex-wrap gap-2 sm:flex-col sm:items-stretch">
                  {p.status === "PENDING" && (
                    <>
                      <Btn variant="success" icon="fa-solid fa-check" onClick={() => approve(p)}>Approve</Btn>
                      <Btn variant="danger" icon="fa-solid fa-xmark" onClick={() => reject(p)}>Reject</Btn>
                    </>
                  )}
                  {p.status === "APPROVED" && (
                    <>
                      <Btn size="sm" variant="soft" icon="fa-solid fa-plus" onClick={() => extend(p)}>दिन बढ़ाएँ</Btn>
                      <Btn size="sm" icon="fa-regular fa-calendar" onClick={() => setEnd(p)}>End date</Btn>
                      {live && <Btn size="sm" className="!text-rose-600" icon="fa-solid fa-ban" onClick={() => act("payUpdate", { id: p.id, op: "cancel" }, "Plan बंद हो गया", { title: "यह plan अभी बंद करें?", text: "User का access तुरंत खत्म हो जाएगा।", danger: true, ok: "बंद करें" })}>Plan बंद करें</Btn>}
                    </>
                  )}
                  {(p.status === "REJECTED" || p.status === "CANCELLED") && <Btn size="sm" icon="fa-solid fa-rotate-left" onClick={() => act("payUpdate", { id: p.id, op: "reopen" }, "फिर से Pending में", { title: "इसे फिर से Pending में डालें?" })}>फिर से देखें</Btn>}
                  <Btn size="sm" icon="fa-regular fa-note-sticky" onClick={async () => { const n = await prompt({ title: "Note", defaultValue: p.note || "" }); if (n !== null) act("payUpdate", { id: p.id, op: "note", note: n }, "Note save हो गया"); }}>Note</Btn>
                  <Btn size="sm" className="!text-rose-600" icon="fa-regular fa-trash-can" onClick={() => act("payDelete", { id: p.id }, "Record delete हो गया", { title: "यह payment record delete करें?", text: "सिर्फ गलत/duplicate entry के लिए।", danger: true })} aria-label="Delete" />
                </div>
              </div>
            );
          })}
          <Card pad={false}><Pager total={data.total} take={TAKE} skip={skip} onChange={setSkip} /></Card>
        </div>
      )}
      {shot && (
        <Modal open onClose={() => setShot(null)} title={`Screenshot — UTR ${shot.utr}`} width={520}
          footer={shot.status === "PENDING" && <><Btn variant="danger" onClick={() => { const p = shot; setShot(null); reject(p); }}>Reject</Btn><Btn variant="success" onClick={() => { const p = shot; setShot(null); approve(p); }}>Approve</Btn></>}>
          <img src={absUrl(shot.screenshot)} alt="Payment screenshot" className="w-full rounded-xl" />
          <a href={absUrl(shot.screenshot)} target="_blank" rel="noreferrer" className="text-xs underline wa-muted mt-2 inline-block">नए tab में खोलें</a>
        </Modal>
      )}
      {grant && <GrantModal onClose={() => setGrant(false)} onDone={reload} />}
    </div>
  );
}
